import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class RafService {
  public customer: CustomerModel;

  constructor(
    private webservices: WebservicesService,
    private userSession: UserSessionService
  ) {
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    )
  }

  public callGetReferrerCode() {
    const customer: CustomerModel = JSON.parse(localStorage.getItem('userSession.customer'));
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken
    }

    return this.webservices.get('raf/get-referrer-code', obj);
  }

  callInviteFriends(names: string, emails: string, code: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
      code: code,
      emails: emails,
      names: names,

    }

    return this.webservices.post('raf/invite-friends', obj);
  }
}
